import { scrollTo } from '@theme/scroll-container';
import { prefersReducedMotion } from '@theme/utilities';
import { StandardEvents } from '@shopify/events';

/**
 * Scrolls back to the top of the page whenever filters, sort or a filter-clear change the results.
 *
 * Every filtering path in facets.js funnels through `FacetsFormComponent.updateFilters()` or
 * `updateFiltersByURL()`, and both dispatch `collection:update` / `search:update`, which bubble to
 * the document. Listening for those covers checkboxes, price ranges, sorting, individual filter
 * removal, clear-all and the quick filters, without touching facets.js itself — so Horizon's
 * upstream sync keeps applying cleanly.
 *
 * Scrolls through `@theme/scroll-container`: above 990px Horizon makes `.page-wrapper` the scroll
 * container and freezes the document, so `window.scrollTo` does nothing there.
 */

/**
 * @param {Event} event - A `collection:update` or `search:update` event.
 */
function scrollToTop(event) {
  const section = event.target instanceof Element ? event.target.closest('.shopify-section') : null;
  if (!section) return;

  // `search:update` also fires for predictive search in the header. Requiring a results list in
  // the same section as the event leaves those alone, so searching from the header doesn't scroll
  // the page behind the overlay.
  if (!section.querySelector('results-list')) return;

  scrollTo({
    top: 0,
    behavior: prefersReducedMotion() ? 'instant' : 'smooth',
  });
}

document.addEventListener(StandardEvents.collectionUpdate, scrollToTop);
document.addEventListener(StandardEvents.searchUpdate, scrollToTop);
